import type { TimestampInMillis, UUID } from '@cobliteam/common-types';

export interface UserOnboarding {
  userId: UUID;
  dismissedAt?: TimestampInMillis;
  startedAt?: TimestampInMillis;
  createdAt: TimestampInMillis;
  endedAt?: TimestampInMillis;
  steps: UserOnboardingStep[];
}

export interface UpdateUserOnboarding {
  started_at?: TimestampInMillis;
  dismissed_at?: TimestampInMillis;
  steps: UpdateUserOnboardingStep[];
}

export interface UpdateUserOnboardingStep {
  step: string;
  started_at?: TimestampInMillis;
  skipped_at?: TimestampInMillis;
  ended_at?: TimestampInMillis;
}

export enum Step {
  UNDERSTOOD = 'UNDERSTOOD',
  INVITE_USER = 'INVITE_USER',
  REGISTER_DRIVER = 'REGISTER_DRIVER',
  REGISTER_GEOFENCE = 'REGISTER_GEOFENCE',
  INSTALL_DEVICE = 'INSTALL_DEVICE',
  ASSOCIATE_VEHICLE = 'ASSOCIATE_VEHICLE',
  ALERT_CONFIG = 'ALERT_CONFIG',
}

export interface StepInfo {
  step: Step;
  skippable: Boolean;
  dependsOn?: Step;
}

export interface UserOnboardingStep {
  stepInfo: StepInfo;
  userId: UUID;
  startedAt?: TimestampInMillis;
  skippedAt?: TimestampInMillis;
  endedAt?: TimestampInMillis;
}
